<template>
  <TConfirmationModal
    ref="createSavedBlockRef"
    close-out-no
    success
    :disabled="disabledConfirm || newName === ''"
  >
    <template #header>{{ $t(`saved_blocks.named_${type}`) }}</template>
    <div class="min-h-[100px] flex-1">
      <ChooseFolder
        :key="`${path.length}-${foldersInPath.length}`"
        :links="path"
        :folders="foldersInPath"
        :actual-path="actualId"
        @choose-folder="chooseFolder"
      />
      <TInput
        v-model="newName"
        data-testid="name-saved-block"
        :label="$t(`saved_blocks.named_${type}`)"
        :error-input="disabledConfirm"
        :error-text="$t('file_manager.file_name_exists', { msg: newName })"
        @update:model-value="checkName"
        @on-focus="
          $event.target.setSelectionRange(0, $event.target.value.length)
        "
      />
    </div>
    <template #confirm-action>
      {{ $t("layout.save") }}
    </template>
  </TConfirmationModal>
</template>

<script setup lang="ts">
  import ChooseFolder from "@/forms/components/SavedContainer/SavedBlocksAPI/_internal/ChooseFolder.vue";
  import useBlocksFromAPI from "@/composables/useBlocksFromAPI";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { ISavedBlockApi } from "@/schemas/savedBlock/savedBlockApiSchema";
  import { TConfirmationModal, TInput } from "@topol/twig-ui";
  import { ref, onMounted } from "vue";

  const props = defineProps<{
    type: ISavedBlockApi["type"];
    index: number;
  }>();

  const {
    getData,
    createSavedBlock,
    savedBlocks,
    path,
    foldersInPath,
    actualId,
  } = useBlocksFromAPI();
  const mjmlStore = useMjmlStore();

  const emits = defineEmits(["create-end"]);

  const createSavedBlockRef = ref();
  const disabledConfirm = ref(false);
  const newName = ref("");

  function checkName() {
    const found = savedBlocks.value.find(
      (sb) => sb.type === props.type && sb.name === newName.value
    );

    if (found !== undefined) {
      disabledConfirm.value = true;
      return;
    } else {
      disabledConfirm.value = false;
    }
  }

  async function chooseFolder(id: number) {
    actualId.value = id;
    savedBlocks.value = await getData(true);
    foldersInPath.value.push(
      savedBlocks.value.filter((item) => item.type === "folder")
    );
    checkName();
  }

  onMounted(async () => {
    if (props.index !== undefined) {
      savedBlocks.value = await getData(true);
      foldersInPath.value.push(
        savedBlocks.value.filter((item) => item.type === "folder")
      );
      const createModal = await createSavedBlockRef.value.open();

      if (createModal === "cancel") {
        emits("create-end");
        return;
      }
      const result = await createSavedBlock({
        name: newName.value,
        type: props.type,
        definition: mjmlStore.getSelectedSectionByIndex(props.index),
        translation: mjmlStore.getSectionTranslationByIndex(props.index),
        index: props.index,
      });

      emits("create-end", result);
      // window.$event.emit("refreshSyncedSectionsList");
    }
  });
</script>
